import classNames from 'classnames'
import {useMemo} from 'react'
import incidentVariableExamples from '../../../data/incidentVariableExamples.json'
import {DateFormats, normalize} from '../../../utils/date'
import {SmallButton} from '../../core/button'
import CustomCalendar from '../../core/calendar'
import Input from '../../core/input'

const VariableInput = ({variable, startTime, onVariableChange, onStartTimeChange}) => {
    if (variable?.type === incidentVariableExamples.last_received_at.type) {
        return (
            <CustomCalendar
                placeholder={variable.label}
                onChange={(date) => onVariableChange(variable.key, date)}
                value={variable.default_value || ''}
                currentDate={normalize(variable.default_value, DateFormats.SLASH_DMY_TIME)}
                isInfoDisabled
                hasTimePicker
                infoIconSize={22}
                startTime={startTime}
                onChangeStartTime={(time) => onStartTimeChange(variable.key, time)}
            />
        )
    }

    return (
        <Input
            id={variable.key}
            name={variable.key}
            containerClassName="variable-input"
            placeholder={variable.label}
            value={variable.default_value || ''}
            onChange={(e) => onVariableChange(variable.key, e.target.value)}
        />
    )
}

const VariablesPanel = ({
    variables,
    visibleVariables,
    hasMoreVariables,
    showMoreVariables,
    isDarkMode,
    text,
    startTime,
    onVariableChange,
    onStartTimeChange,
    onToggleShowAll
}) => {
    const variableOptions = useMemo(() => Object.values(incidentVariableExamples), [incidentVariableExamples])

    return  <div className={classNames('variables-panel', {dark: isDarkMode})}>
        <div className={classNames('variables-grid', {dark: isDarkMode})}>
            {(showMoreVariables ? variables : visibleVariables).map((variable) => (
                <div className="variable-item" key={variable.key}>
                    <span className='variable-name'>{variable.key}</span>
                    <VariableInput
                        variable={variable}
                        startTime={startTime}
                        onVariableChange={onVariableChange}
                        onStartTimeChange={onStartTimeChange}
                    />
                </div>
            ))}
        </div>
        {hasMoreVariables && (
            <SmallButton className="btn-toggle-variables" type="button" onClick={onToggleShowAll}>
                {showMoreVariables
                    ? text.show_less
                    : `+ ${variableOptions.length - visibleVariables.length} ${text.show_more}`}
            </SmallButton>
        )}
    </div>
}

export default VariablesPanel
